//
//
//
//
//
//

export default {
  name: 'Spinner',
  props: {
    active: {
      type: Boolean,
      default: false,
    },
  },
}
